type ItranformSrpBreadcrumbData = Array<{
  link: string;
  title: string;
  routeUrl?: string;
  text: string;
}>;

export const tranformSrpBreadcrumbData = (data: ItranformSrpBreadcrumbData) => {
  const newData = data.map(({link, title, routeUrl, text}) => ({
    href: link,
    name: text ? text : title,
    routeUrl,
  }));
  return newData;
};
